import gql from "graphql-tag";
import { FreeCreditTypeDetailFragment } from "../fragments/free.credit.fragment";

export const UPDATE_ONE_FREE_CREDIT_TYPE_DETAIL = gql`
  mutation ($input: UpdateOneFreeCreditTypeDetailInput!) {
    updateOneFreeCreditTypeDetail(input: $input) {
      ...FreeCreditTypeDetail
    }
  }
  ${FreeCreditTypeDetailFragment}
`;
